'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _bookAppointmentModal = require('../actions/book-appointment-modal');

var _pageActions = require('../actions/page-actions');

var _reduxSimpleAuth = require('redux-simple-auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	isOpen: false,
	modalDisplayPage: 'loginOrSignUp',
	requestData: {
		appointment_time: '',
		appointment_type: '',
		attributes: {
			comments: '',
			patient_fullname: ''
		},
		created_by: 'patient',
		insurance_type: '',
		patient: '',
		patient_contact_email: '',
		patient_contact_telephone: '',
		practice: '',
		practice_aggregate_review: 0,
		practice_review: {},
		reason_for_visit: '',
		patient_claim_number: '',
		patient_policy_number: '',
		source_application: 'website',
		specialist: '',
		specialist_aggregate_review: null,
		specialist_review: {}
	},
	submitAttempted: false,
	submitSuccessful: false,
	login: {
		error: false,
		email: '',
		rememberMe: false,
		submitAttempted: false,
		submitFailed: false,
		validEmail: false
	},
	patient: {
		firstname: '',
		lastname: '',
		email: ''
	},
	specialistName: '',
	appointmentDatetime: '',
	validPhone: false,
	validInsurer: false,
	validVisitedOption: false,
	validClaimNumber: false,
	validPolicyNumber: false
};

var transformRequestData = function transformRequestData(_ref) {
	var state = _ref.state,
	    account = _ref.account,
	    profile = _ref.profile;

	return {
		requestData: (0, _extends3.default)({}, state.requestData, {
			patient: profile.uuid,
			attributes: (0, _extends3.default)({}, state.attributes, {
				patient_fullname: '' + profile.firstname + (profile.lastname ? ' ' + profile.lastname : '')
			}),
			patient_contact_email: account.name
		}),
		modalDisplayPage: ''
	};
};

var bookAppointmentModal = function bookAppointmentModal(state, action) {
	switch (action.type) {
		case _pageActions.LOAD_SPECIALIST_PROFILE + '_RECEIVED':
			{
				var defaultPractice = action.response.practices[0];
				var specialist = action.response.specialist;
				return (0, _assign2.default)({}, state, {
					requestData: (0, _extends3.default)({}, state.requestData, {
						practice: defaultPractice && defaultPractice.practice_id,
						practice_aggregate_review: defaultPractice && defaultPractice.practice_average_review || 0,
						specialist: specialist.id
					}),
					specialistName: specialist.name
				});
			}
		case _bookAppointmentModal.OPEN_BOOK_APPOINTMENT_MODAL:
			{
				return (0, _assign2.default)({}, state, {
					isOpen: true,
					requestData: (0, _extends3.default)({}, state.requestData, {
						appointment_time: action.time,
						practice: action.practice && action.practice.id
					}),
					appointmentDatetime: _moment2.default.utc(JSON.parse(action.time)[0]).format('DD-MM-YYYY HH:mm'),
					practiceName: action.practice && action.practice.name
				});
			}
		case _bookAppointmentModal.CLOSE_BOOK_APPOINTMENT_MODAL:
			return (0, _assign2.default)({}, state, {
				isOpen: false,
				modalDisplayPage: 'loginOrSignUp',
				submitAttempted: false,
				submitSuccessful: false,
				appointmentDatetime: '',
				validPhone: false,
				validInsurer: false,
				validVisitedOption: false,
				error: false,
				submitFailed: false,
				errorMessage: '',
				requestData: (0, _extends3.default)({}, state.requestData, {
					patient_contact_telephone: '',
					appointment_type: '',
					insurance_type: '',
					reason_for_visit: ''
				})
			});
		case _bookAppointmentModal.PHONE_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { patient_contact_telephone: action.phone }) });
		case _bookAppointmentModal.CLAIM_NUMBER_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { patient_claim_number: action.claimNumber }) });
		case _bookAppointmentModal.POLICY_NUMBER_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { patient_policy_number: action.policyNumber }) });
		case _bookAppointmentModal.VISITED_OPTION_SELECTED:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { appointment_type: action.option === 'n' ? 'new' : 'follow-up' }), validVisitedOption: true });
		case _bookAppointmentModal.INSURANCE_SELECTED:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { insurance_type: parseInt(action.insurer) }), validInsurer: true });
		case _bookAppointmentModal.VISIT_REASON_CHANGE:
			return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { reason_for_visit: action.message }) });
		case _bookAppointmentModal.SUBMIT_REQUEST + '_REQUESTED':
			return (0, _assign2.default)({}, state, { submitAttempted: true });
		case _bookAppointmentModal.SUBMIT_REQUEST + '_RECEIVED':
			return (0, _assign2.default)({}, state, { submitSuccessful: true });
		case _bookAppointmentModal.VALIDATION_FAILED:
			return (0, _assign2.default)({}, state, { submitFailed: true, submitAttempted: true });
		case _bookAppointmentModal.SET_VALID_PHONE:
			return (0, _assign2.default)({}, state, { validPhone: action.valid });
		case _bookAppointmentModal.SET_VALID_CLAIM_NUMBER:
			return (0, _assign2.default)({}, state, { validClaimNumber: action.valid });
		case _bookAppointmentModal.SET_VALID_POLICY_NUMBER:
			return (0, _assign2.default)({}, state, { validPolicyNumber: action.valid });
		case _bookAppointmentModal.SHOW_LOGIN:
			return (0, _assign2.default)({}, state, { modalDisplayPage: 'login' });
		case _bookAppointmentModal.LOGIN_EMAIL_CHANGE:
			return (0, _assign2.default)({}, state, { login: (0, _extends3.default)({}, state.login, { email: action.email }) });
		case _bookAppointmentModal.LOGIN_REMEMBER_ME_CHECKED:
			return (0, _assign2.default)({}, state, { login: (0, _extends3.default)({}, state.login, { rememberMe: !action.rememberMe }) });
		case _reduxSimpleAuth.actionTypes.RESTORE:
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_SUCCEEDED:
			{
				return (0, _assign2.default)({}, state, transformRequestData({
					state: state,
					account: action.payload.account,
					profile: action.payload.selectedProfile
				}), {
					login: (0, _extends3.default)({}, state.login, {
						error: false,
						submitAttempted: true,
						submitFailed: false
					})
				});
			}
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_FAILED:
			{
				var errorMessage = action && action.payload && action.payload.response && action.payload.response.data;
				var msg = errorMessage && errorMessage === 'null value in column "email" violates not-null constraint' ? 'Please enter your details' : action.payload.response.data;
				return (0, _assign2.default)({}, state, {
					login: (0, _extends3.default)({}, state.login, {
						error: true,
						submitAttempted: true,
						errorMessage: msg || 'There is an error with our servers. Please try again later.'
					})
				});
			}
		case _reduxSimpleAuth.actionTypes.INVALIDATE_SESSION:
			return (0, _assign2.default)({}, state, {
				requestData: (0, _extends3.default)({}, state.requestData, {
					patient: '',
					attributes: (0, _extends3.default)({}, state.attributes, {
						patient_fullname: ''
					}),
					patient_contact_email: ''
				}),
				modalDisplayPage: 'loginOrSignUp'
			});
		case _bookAppointmentModal.LOGIN_SET_VALID_EMAIL:
			return (0, _assign2.default)({}, state, {
				login: (0, _extends3.default)({}, state.login, {
					validEmail: action.valid
				})
			});
		case _bookAppointmentModal.LOGIN_VALIDATION_FAILED:
			return (0, _assign2.default)({}, state, {
				login: (0, _extends3.default)({}, state.login, {
					submitAttempted: true,
					submitFailed: true,
					error: true
				})
			});
		// Next 2 === janky hack for booking appt auth flow. See also book appt modal, global redux, and sign up modal.
		case 'SIGN_UP_MODAL:SET_BOOKING_FLOW_AUTH_INFO':
			{
				return (0, _assign2.default)({}, state, {
					requestData: (0, _extends3.default)({}, state.requestData, {
						patient_contact_email: action.info.email
					})
				});
			}
		case 'SIGN_UP_MODAL:PATIENT_CALL_RECEIVED':
			{
				return (0, _assign2.default)({}, state, {
					requestData: (0, _extends3.default)({}, state.requestData, {
						patient: action.response.patient.id,
						attributes: (0, _extends3.default)({}, state.requestData.attributes, {
							patient_fullname: action.response.name
						})
					})
				});
			}
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = bookAppointmentModal;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/reducers/book-appointment-modal.js